import { Component, Input, forwardRef, OnInit, ElementRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { Params } from '@angular/router';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisSearchResultComponent } from '../../genericsearch/component/his-search-result.component';

/**
 * Komponente für Links (egal ob routerLink oder href) mit Icon und/oder Text.
 */
@Component( {
    selector: 'his-link',
    templateUrl: './his-link.compoment.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HisLinkComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisLinkComponent implements OnInit {
    private navigationService = inject(HisNavigationService);
    private elementRef = inject(ElementRef);


    /** 
     * Der routerLink kannn als string oder als array von Segementen übergeben werden.
     * Seit Angular 19 darf das Attribut nicht routerLink heissen, weil sonst die <his-link>-Komponente klickbar ist egal wie das disabled-Attribut aussieht.
     */
    @Input() route: string | string[];
    /** URL-Parameter für den routerLink */
    @Input() queryParams: Params;

    /** URL state Parameter */
    @Input() state: any;
    /**
     * Alternativ zu routerLink kann ein href benutzt werden.
     * Das macht man üblicherweise nur, wenn das Ziel in einem anderen Projekt liegt.
     */
    @Input() href: string;

    /** Icon. Das Attribut darf nicht hisImage heissen wegen der his-image.directive */
    @Input() img: string;

    /** Text */
    @Input() text: string;
    
    @Input() disabled: boolean;
    @Input() title: string; // tooltip
    @Input() activeClass: string; // CSS class for active links
    
    /** Der häufigste Use case einer Aktion vor dem Navigieren */
    @Input() setLastBackUrl: boolean = false;
    /** Funktion für komplexere Aktionen vor der Navigation */
    @Input() onBeforeNavigateFunction: () => void;

    /**
     * necessary to pipe the data to HisSearchResultHeaderContextProviderDirective for usage in search results
     */
    @Input() genericSearchResult?: HisSearchResultComponent;
    @Input() genericSearchResultIndex?: number;

    ngOnInit(): void {
        // tabIndex=0 am his-icon-link entfernen damit man nicht 2x tabben muss um zum nächsten Element zu kommen
        this.elementRef.nativeElement.tabIndex = -1;
    }

    /**
     * Aktionen bevor der Link aufgerufen wird.
     * 
     * (Da Javascript single-threaded ist sollte das hier immer ausgeführt werden bevor der Link aufgerufen wird.)
     * (Die Funktion onBeforeNavigateFunction darf bloss keine asynchrone Ausführung beinhalten.                 )
     */ 
    onBeforeNavigate(): void {
        if (this.setLastBackUrl === true) {
            this.navigationService.setLastBackUrl();
        }

        if (this.onBeforeNavigateFunction) {
            this.onBeforeNavigateFunction();
        }
    }
}
